module.exports = __webpack_public_path__ + "img/handraw_satisfaction - footer copie.6fe4c97e.svg";